import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var fog = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_wytd9v4',variantClassNames:{side:{top:'fx_2d2fb1e5_wytd9v5',bottom:'fx_2d2fb1e5_wytd9v6',right:'fx_2d2fb1e5_wytd9v7',left:'fx_2d2fb1e5_wytd9v8'}},defaultVariants:{},compoundVariants:[]});
var fogBackgroundColorVar = 'var(--fx_2d2fb1e5_wytd9v3)';
var scrollbar = 'fx_2d2fb1e5_wytd9v1';
var thumb = 'fx_2d2fb1e5_wytd9v2';
var viewport = 'fx_2d2fb1e5_wytd9v0';

export { fog, fogBackgroundColorVar, scrollbar, thumb, viewport };
//# sourceMappingURL=scrollArea.vanilla.mjs.map
